import { ReactComponent as Change } from './change.svg';

export default Change;
